import React from 'react';

import { BoxProps } from '@waglabs/box-next';
import { Image } from '@waglabs/image-next';
import { Typography } from '@waglabs/typography';

export type ImageTypographyPairProps = {
  gridRow: string;
  gridColumnImage: string;
  gridColumnText: string;
  src: string; // Adjust the type if `src` is not a string
  children: React.ReactNode; // For the text content
} & BoxProps;
export const ImageTypographyPair = ({
  gridRow,
  gridColumnImage,
  gridColumnText,
  marginTop,
  src,
  fontFamily,
  children,
}: ImageTypographyPairProps) => (
  <>
    <Image
      gridRow={gridRow}
      gridColumn={gridColumnImage}
      mt={marginTop}
      mr="16px"
      src={src}
    />
    <Typography
      gridRow={gridRow}
      gridColumn={gridColumnText}
      fontFamily={fontFamily}
    >
      {children}
    </Typography>
  </>
);
